<template>
    <div>
        <b-card class="mb-4">
            <b-card-title class="mb-4">RELEVANTE LEVERINGEN</b-card-title>

            <dispatch-requests :sales-order="salesOrder" :dispatch-requests="dispatchRequestsWithRequiredDecision" :hide-actions="true">
                <template #extraActions="data">
                    <b-button variant="primary" @click="openDecisionModal(data.dispatchRequest)" class="mb-4 mb-xl-0">
                        Vervolgactiekeuze
                    </b-button>
                </template>
            </dispatch-requests>

            <p v-if="!dispatchRequestsWithRequiredDecision.length">
                <i>Deze order heeft op dit moment geen leveringen die een vervolgactiekeuze vereisen.</i>
            </p>
        </b-card>

        <b-modal id="dispatch-request-decision-modal"
                 size="xl"
                 centered
                 hide-footer
                 dialog-class="shadow-none"
                 title="Producten naleveren of crediteren"
        >
            <final-dispatch-request-actions action="add-extra-order-lines-and-refund-remaining"
                                            :sales-order="salesOrder"
                                            :override-dispatch-requests="[currentDispatchRequest]"
                                            :is-modal="false"
            />
        </b-modal>
    </div>
</template>

<script>
import DispatchRequests from "@/views/OrderDetail/components/DispatchRequests.vue";
import FinalDispatchRequestActions from "@/views/OrderDetail/components/FinalDispatchRequestActions.vue";

export default {
    name: "NextActionDecision",
    components: {FinalDispatchRequestActions, DispatchRequests},

    props: {
        salesOrder: {required: true, type: Object},
    },

    data() {
        return {
            currentDispatchRequest: null,
        }
    },

    computed: {
        dispatchRequestsWithRequiredDecision() {
            return this.salesOrder.current_dispatch_requests
                .filter(drq => drq.requires_next_action_decision)
        },
    },

    methods: {
        openDecisionModal(dispatchRequest) {
            this.currentDispatchRequest = dispatchRequest;
            this.$bvModal.show('dispatch-request-decision-modal')
        },
    },
}
</script>
